import React from 'react';
import Plus from '../../content/Plus';
import LinkButton from '../LinkButton';

export type AddOrderCommentButtonProps = {
  onAddOrderCommentClicked: () => void;
};

const AddOrderCommentButton: React.FC<AddOrderCommentButtonProps> = ({
  onAddOrderCommentClicked,
}: AddOrderCommentButtonProps) => {
  return (
    <LinkButton onClick={onAddOrderCommentClicked} toolTipKey="OrderComment">
      <div className="flex flex-row space-x-2">
        <span className="pt-1">
          <Plus />
        </span>
        <span className="text-sm">Add Order Comment</span>
      </div>
    </LinkButton>
  );
};

export default AddOrderCommentButton;
